<app-uni-dialog  [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  
  <div class="flex flex-row w-full h-full">
    <div *ngIf="joPullBatches.length == 0" class="h3">No outstanding Job Order Pull Batches found</div>
    <app-ag-grid class="mt-3 pb-3" style="height: 100%" *ngIf="joPullBatches.length > 0" [gridOptions]="jopbGridOptions" [rowData]="joPullBatches"></app-ag-grid>
  </div>
    
  
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button (click)="selectBatch()" pButton type="button" class="p-button-raised">Select Batch</button>
    <button (click)="close()" pButton type="button" class="p-button-raised">Cancel</button>
  </div>
</ng-template>
